<main>
  <section class="white-box">
    <h1 class="box-title">Coming soon…</h1>
    <p>We are working on enabling this feature in the near future.</p>
    <p *ngIf="message">{{ message }}</p>
  </section>
</main>